import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  projectForTest: {
    marginTop: '67px',
    alignItems: 'center',
  },
  projectTitle: {
    backgroundImage: `url(${require('./assets/titleBg.png')})`,
    backgroundSize: '100%  100%',
    backgroundRepeat: 'no-repeat',
    width: 95,
    height: 65,
    fontSize: '23px',
    fontWeight: 500,
    alignItems: 'center',
    justifyContent: 'center',
  },
  projectBg: {
    width: '1000px',
    backgroundColor: 'white',
    alignItems: 'center',
    marginTop: '20px',
    backgroundImage: `url(${require('./assets/bottomBg.png')})`,
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom left',
    padding: '40px',
  },
  button: {
    backgroundColor: '#385DAE',
    marginTop: '32px',
    ':hover': {
      backgroundColor: '#4769b4',
    },
  },
  projectText: {
    marginTop: '20px',
    fontSize: '14px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(50,54,58,1)',
    lineHeight: '20px',
  },
});



// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/common/project/styles.js